import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Utils from 'helpers/utils.js';
import { Button } from '@kambria/kambria-lego';
import { getOrderHistory } from 'redux/actions/order.action';
import enums from 'helpers/const';

const INITAL_LIMIT = 5;
const PAYMENT_METHODS = Utils.setValueLikeKeyObject(enums.PAYMENT_METHODS);

class OrderHistory extends React.Component {
  componentDidMount() {
    const { getOrderHistory } = this.props;
    getOrderHistory(INITAL_LIMIT, 1);
  }

  onLoadMore = () => {
    const { getOrderHistory, order } = this.props;
    getOrderHistory(order.pagination.limit + 5, 1);
  };

  btnLoadMore = (
    <Button type="gray" size="sm" onClick={this.onLoadMore}>
      Load more
    </Button>
  );

  renderLoadMoreBtn = () => {
    const { order } = this.props;
    if (order.pagination.limit < order.pagination.total) {
      return this.btnLoadMore;
    }
  };

  renderStatusTransaction = (status) => {
    switch (status) {
      case '0':
        return <span style={{ color: 'orange' }}>PENDING</span>;
      case '1':
        return <span style={{ color: 'limegreen' }}>SUCCESSFUL</span>;
      case '2':
        return <span style={{ color: 'red' }}>FAIL</span>;
      case '3':
        return <span style={{ color: 'gray' }}>CANCELLED</span>;
      default:
        return null;
    }
  };

  getPayPrice = ({ payment_method, total_price, type, product }) => {
    const { price, price_usd } = product;
    let pay = '';
    if ([PAYMENT_METHODS.KAT, PAYMENT_METHODS.KAT_WALLET].includes(payment_method)) {
      pay = `${total_price}KAT`;
    }
    if ([PAYMENT_METHODS.KYTE, PAYMENT_METHODS.KYTE_WALLET].includes(payment_method)) {
      pay = `${total_price}KYTE`;
    }
    if (payment_method === PAYMENT_METHODS.PAYPAL) {
      pay = Utils.formatPrice({ price: price_usd, type });
    }
    if (payment_method === PAYMENT_METHODS.VNBANK) {
      pay = Utils.formatPrice({ price, type });
    }
    console.log('pay', pay);
    return pay;
  };

  render() {
    const { order } = this.props;
    return (
        <div></div>
    )
  }
}

const mapStateToProps = ({ order }) => ({
  order,
});

const mapDispatchToProps = {
  getOrderHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderHistory);
